/**
 * 服務類型 分類ID
 * @enum {string}
 */
export const MAIN_TYPE_ATTRIBUTE_ID = {
  /** 社區團購 */
  COMM_BUY_TOGETHER: 0,
  /** 社區便利服務 */
  COMM_CONVENIENCE: 1,
  /** 到府服務 */
  HOME_VISIT: '2'
}

export default {
  MAIN_TYPE_ATTRIBUTE_ID
}
